import React from "react";
import { faBan, faSpinner } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Button from "@/components/button";
import { ButtonBar, Module } from "@/components/layouts";
import { ButtonGroup } from "@/components/layouts/button-group";
import { ProgressBar } from "@/components/progress-bar/progress-bar";

import ModalTitle from "./modal-title";

type SavingModalProps = {
  progress: number;
  message: string;
  version?: number;
  onCancel: () => void;
};

export default function SavingModal({
  progress = 0,
  message,
  version,
  onCancel,
}: SavingModalProps) {
  return (
    <div className="text-center">
      <ModalTitle>Saving</ModalTitle>
      <Module>
        <p>{message}</p>
        <p className="text-xs">{version ? `Version: ${version}` : "-"}</p>
      </Module>
      <div className="text-5xl text-gray-500">
        <FontAwesomeIcon icon={faSpinner} spin />
      </div>
      <Module>
        {progress !== null && <ProgressBar progressPercent={progress} />}
      </Module>
      <ButtonBar>
        <ButtonGroup align="centre">
          <Button onClick={onCancel} type="negative" centre>
            <FontAwesomeIcon icon={faBan} /> Cancel
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
}
